import React from 'react'
import { Spinner } from 'react-bootstrap'

const ButtonLoadingV1 = () => (
  <Spinner
    className='button__loader'
    as='span'
    animation='border'
    size='sm'
    role='status'
    aria-hidden='true'
  />
)

export default ButtonLoadingV1
